/* tslint:disable:object-literal-sort-keys */

export const QuizType = {
  NOTIFICATION: { label: '注意書き', value: -1 },
  FIRSTPAGE: { label: '表紙', value: 0 },
  QUESTION: { label: 'クイズ', value: 1 },
  RANKING: { label: '結果発表', value: 2 },
  COMPLETE: { label: '完了', value: 3 }
}

export const QuestionType = {
  FOURCHOICE: { label: '四択クイズ', value: 0 },
  TRUEFALSE: { label: 'マルバツクイズ', value: 1 },
  REALTIME: { label: '実演クイズ', value: 2 }
}

export const QuestionTypeList = [QuestionType.FOURCHOICE, QuestionType.TRUEFALSE, QuestionType.REALTIME]

export const QuestionTimeLimit = {
  TEN: { label: '10秒(短め)', value: 10 },
  THIRTY: { label: '30秒(普通)', value: 30 },
  SIXTY: { label: '60秒(長め)', value: 60 }
}

export const QuestionTimeLimitList = [QuestionTimeLimit.TEN, QuestionTimeLimit.THIRTY, QuestionTimeLimit.SIXTY]

export const RankingType = {
  ALL: { label: '全員発表', value: 0 },
  FROMTHREE: { label: '3位から発表', value: 3 },
  FROMFIVE: { label: '5位から発表', value: 5 },
  FROMTEN: { label: '10位から発表', value: 10 },
  FROMFIFTEEN: { label: '15位から発表', value: 15 },
  FROMTHIRTY: { label: '30位から発表', value: 30 }
}

export const RankingTypeList = [
  RankingType.ALL,
  RankingType.FROMTHREE,
  RankingType.FROMFIVE,
  RankingType.FROMTEN,
  RankingType.FROMFIFTEEN,
  RankingType.FROMTHIRTY
]

export enum MemberStatus {
  GUEST,
  MEMBER,
  PAID
}
